export function hasProperty(data, key) {
    return key in data;
}
//# sourceMappingURL=hasProperty.js.map